import type { ChatConversation, ConversationsResponse } from '@/types/chat'

export async function getConversations(page = 1, limit = 10): Promise<ConversationsResponse> {
  const response = await fetch(`/api/v1/chats?page=${page}&limit=${limit}`)
  const data = await response.json()

  return {
    data,
    meta: {
      currentPage: page,
      totalPages: Math.ceil(data.length / limit),
      totalItems: data.length
    }
  }
}

export async function getConversation(id: number): Promise<ChatConversation> {
  const response = await fetch(`/api/v1/chats/${id}`)
  const conversation = await response.json()

  if (!conversation) {
    throw new Error('Conversation not found')
  }

  return conversation
}

export async function updateConversationTitle(id: number, title: string): Promise<ChatConversation> {
  const response = await fetch(`/api/v1/chats/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "",
    },
    body: JSON.stringify({ title })
  })

  const conversation = await response.json()

  if (!conversation) {
    throw new Error('Conversation not found')
  }

  return conversation
}